import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchServicesSectionPublic = () => axios.get(`${API}/services-section`);
export const fetchServicesSectionAdmin = () => axios.get(`${API}/services-section/admin`);
export const saveServicesSection = (data) => axios.put(`${API}/services-section`, data);

export const uploadServiceMedia = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${API}/services-section/upload-media`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  });
};

export const deleteServiceMedia = (publicId, resourceType) =>
  axios.delete(`${API}/services-section/media`, { params: { public_id: publicId, resource_type: resourceType } });
